(() => {
  if (!customElements.get('sc-track-form')) {
    class TrackForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="code"]');
        this.bar = this.querySelector('[data-track-bar]');
        this.error = this.querySelector('[data-track-error]');
        this.errorText = this.querySelector('[data-track-error-text]');
        if (!this.form || !this.input || this.dataset.bound) return;
        this.dataset.bound = '1';

        const params = new URLSearchParams(window.location.search);
        const preset = params.get('code') || params.get('numero');
        if (preset && !this.input.value) this.input.value = this.clean(preset);

        this.form.addEventListener('submit', (e) => this.onSubmit(e));
        this.input.addEventListener('input', () => this.setError(''));
      }

      clean(value) {
        return value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      }

      onSubmit(e) {
        const code = this.clean(this.input.value);
        if (!code) {
          e.preventDefault();
          this.setError(this.dataset.errorEmpty);
          return;
        }
        // Colissimo: 13 characters (6A12345678901, or CB123456789FR abroad), always a long run of digits
        if (!/^[A-Z0-9]{10,15}$/.test(code) || !/\d{8}/.test(code)) {
          e.preventDefault();
          this.setError(this.dataset.errorFormat);
          return;
        }
        this.input.value = code;
      }

      setError(message) {
        if (!this.error) return;
        this.error.hidden = !message;
        this.errorText.textContent = message || '';
        this.input.setAttribute('aria-invalid', message ? 'true' : 'false');
        this.bar.classList.remove('is-invalid');
        if (message) {
          void this.bar.offsetWidth;
          this.bar.classList.add('is-invalid');
          this.input.focus();
        }
      }
    }
    customElements.define('sc-track-form', TrackForm);
  }

  if (!customElements.get('sc-open-status')) {
    const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

    class OpenStatus extends HTMLElement {
      connectedCallback() {
        this.update();
        this.timer = window.setInterval(() => this.update(), 60000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      toMinutes(value) {
        const m = /^(\d{1,2})(?:[:hH](\d{2})?)?$/.exec((value || '').trim());
        return m ? Number(m[1]) * 60 + Number(m[2] || 0) : null;
      }

      format(minutes) {
        const h = Math.floor(minutes / 60);
        const m = minutes % 60;
        return `${h}h${m ? String(m).padStart(2, '0') : ''}`;
      }

      // day: 1 = Monday … 7 = Sunday, in the shop's time zone
      now() {
        const parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: this.dataset.tz || 'Europe/Paris',
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23',
        }).formatToParts(new Date());
        const get = (type) => (parts.find((p) => p.type === type) || {}).value;
        return {
          day: WEEKDAYS.indexOf(get('weekday')) + 1,
          minutes: Number(get('hour')) * 60 + Number(get('minute')),
        };
      }

      update() {
        const days = (this.dataset.days || '')
          .split(',')
          .map((d) => Number(d.trim()))
          .filter((d) => d >= 1 && d <= 7);
        const open = this.toMinutes(this.dataset.open);
        const close = this.toMinutes(this.dataset.close);
        const title = this.querySelector('[data-status-title]');
        const detail = this.querySelector('[data-status-detail]');
        if (!days.length || open === null || close === null || !title || !detail) return;

        const { day, minutes } = this.now();
        if (day < 1) return;
        const names = (this.dataset.dayNames || '').split(',');
        const isOpen = days.includes(day) && minutes >= open && minutes < close;
        this.classList.toggle('is-open', isOpen);
        this.classList.toggle('is-closed', !isOpen);

        if (isOpen) {
          title.textContent = this.dataset.openLabel;
          detail.textContent = this.dataset.closesLabel.replace('[time]', this.format(close));
          return;
        }

        title.textContent = this.dataset.closedLabel;
        if (days.includes(day) && minutes < open) {
          detail.textContent = this.dataset.todayLabel.replace('[time]', this.format(open));
          return;
        }
        for (let i = 1; i <= 7; i += 1) {
          const next = ((day - 1 + i) % 7) + 1;
          if (days.includes(next)) {
            const label = i === 1 ? this.dataset.tomorrowLabel : this.dataset.dayLabel.replace('[day]', names[next - 1] || '');
            detail.textContent = label.replace('[time]', this.format(open));
            return;
          }
        }
      }
    }
    customElements.define('sc-open-status', OpenStatus);
  }

  /* Contact form: ?sujet= picks the first subject containing that word, ?message= fills an empty
     message (link of the "atelier complet" button) */
  const query = new URLSearchParams(window.location.search);
  const subjectSelect = document.getElementById('ContactSubject');
  const bodyField = document.getElementById('ContactBody');
  const wanted = (query.get('sujet') || '').toLowerCase();
  if (subjectSelect && wanted) {
    const match = Array.from(subjectSelect.options).find((o) => o.text.toLowerCase().includes(wanted));
    if (match) subjectSelect.value = match.value;
  }
  if (bodyField && !bodyField.value && query.get('message')) bodyField.value = query.get('message');
})();
